import { render } from "./ManifestShipmentTable.vue?vue&type=template&id=54e49606&scoped=true"
import script from "./ManifestShipmentTable.vue?vue&type=script&lang=js"
export * from "./ManifestShipmentTable.vue?vue&type=script&lang=js"

import "./ManifestShipmentTable.vue?vue&type=style&index=0&id=54e49606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e49606"]])

export default __exports__